import {createTheme} from "@mui/material/styles";

const theme = createTheme({
    palette: {
        background: {
            default: "#F9F0E0",
        },
        primary: {
            main: "#803D1F",
        },
        secondary: {
            main: "#DDCAAC",
        },
        footer: {
            default: "#3C2C1F",
        }
    },

    // Global font
    typography: {
        fontFamily: "'Cervino Neue', Arial, sans-serif",
        fontWeightLight: 400,
        fontWeightRegular: 500,
        fontWeightMedium: 700,
        fontWeightBold: 900,
    },

    components: {
        MuiCssBaseline: {
            styleOverrides: `
            @font-face {
              font-family: 'Cervino Neue';
              src: url('/fonts/Cervino-Regular.woff2') format('woff2');
              font-weight: 400;
              font-style: normal;
              font-display: swap;
            }
        
            @font-face {
              font-family: 'Cervino Neue';
              src: url('/fonts/Cervino-Medium.woff2') format('woff2');
              font-weight: 500;
              font-style: normal;
              font-display: swap;
            }
        
            @font-face {
              font-family: 'Cervino Neue';
              src: url('/fonts/Cervino-Bold.woff2') format('woff2');
              font-weight: 700;
              font-style: normal;
              font-display: swap;
            }
        
            @font-face {
              font-family: 'Cervino Neue';
              src: url('/fonts/Cervino-BlackNeue.woff2') format('woff2');
              font-weight: 900;
              font-style: normal;
              font-display: swap;
            }
            
            .mapboxgl-popup-close-button {
              color: #000 !important;
              font-size: 22px;
              width: 32px;
              height: 32px;
            }
            
            .mapboxgl-popup-close-button:hover {
              background-color: rgba(0, 0, 0, 0.08);
              border-radius: 50%;
            }
            
            .mapboxgl-popup-content {
              padding: 10px;
            }
          `,
        }

    },
});

export default theme;
